import { File } from "@prisma/client";
import { ImageComponent } from "./ImageComponent";

export interface ImageSliderOwnProps {
  images: File[];
}

export function ImageSlider({ images }: ImageSliderOwnProps) {
  return !!images.length ? (
    <div className="overflow-x-auto snap-x snap-mandatory my-4">
      <div className="flex flex-row flex-nowrap gap-8">
        {images.map((image) => (
          <ImageComponent
            key={image.id}
            image={image}
            className="snap-start max-w-[90%]"
            imageClassName="h-[250px] md:h-[450px] object-contain"
            transformation={[{ height: 900 }]}
          />
        ))}
      </div>
    </div>
  ) : null;
}
